/* Purkal size guide drawer.
   Chart data is rendered by snippets/purkal-size-guide.liquid into a
   <script type="application/json"> inside the element. Values are INCHES;
   centimetres are derived so the two units can never drift apart. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.pkReady) return;
    root.dataset.pkReady = '1';

    /* The picker sits inside ancestors that create a containing block for
       position:fixed (transforms on the product info column), which would pin
       the drawer to that column instead of the viewport. Reparent to body. */
    if (root.parentNode !== document.body) document.body.appendChild(root);

    var dataEl = root.querySelector('[data-pk-sg-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var veil = root.querySelector('.pk-sg-veil');
    var panel = root.querySelector('.pk-sg');
    var thead = root.querySelector('[data-pk-thead]');
    var tbody = root.querySelector('[data-pk-tbody]');
    var fit = root.querySelector('[data-pk-fit]');
    var model = root.querySelector('[data-pk-model]');
    var howList = root.querySelector('[data-pk-how]');
    var closeBtn = root.querySelector('.pk-sg-x');
    var unit = 'in';
    var lastFocus = null;

    function toCm(v) { return Math.round(v * 2.54 * 2) / 2; }

    /* whichever size the shopper has selected on the PDP gets highlighted */
    function selectedSize() {
      var picked = document.querySelector(
        '.product-form__input--pill input[type="radio"]:checked, ' +
        '.product-form__input--swatch input[type="radio"]:checked'
      );
      var val = picked ? picked.value : null;
      if (!val) {
        var sel = document.querySelector('.product-form__input--dropdown .select__select');
        if (sel) val = sel.value;
      }
      return val ? val.trim().toLowerCase() : null;
    }

    function render() {
      var picked = selectedSize();
      thead.innerHTML = data.cols.map(function (h, i) {
        return '<th>' + h + (i ? ' <span style="opacity:.6">(' + unit + ')</span>' : '') + '</th>';
      }).join('');
      tbody.innerHTML = data.rows.map(function (r) {
        var name = String(r[0]).toLowerCase();
        var hit = picked && (picked === name || picked.charAt(0) === name.charAt(0));
        var cells = r.map(function (v, i) {
          if (i === 0) return '<td>' + v + '</td>';
          if (typeof v !== 'number') return '<td>' + v + '</td>';
          return '<td>' + (unit === 'in' ? v : toCm(v)) + '</td>';
        }).join('');
        return '<tr class="' + (hit ? 'pk-pick' : '') + '">' + cells + '</tr>';
      }).join('');
      fit.innerHTML = data.fit;
      model.textContent = data.model || '';
      howList.innerHTML = data.how.map(function (h) {
        return '<li><b>' + h[0] + '</b><span>' + h[1] + '</span></li>';
      }).join('');
    }

    function onKey(e) {
      if (e.key === 'Escape') return close();
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      lastFocus = document.activeElement;
      render();
      veil.classList.add('pk-on');
      panel.classList.add('pk-on');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      veil.classList.remove('pk-on');
      panel.classList.remove('pk-on');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* the trigger lives up in the variant picker, outside this element */
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.pk-sg-btn') : null;
      if (!b) return;
      e.preventDefault();
      open();
    });

    closeBtn.addEventListener('click', close);
    veil.addEventListener('click', close);

    root.querySelector('.pk-sg-tabs').addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      [].forEach.call(this.children, function (x) { x.classList.toggle('pk-on', x === b); });
      root.querySelector('[data-pk-pane="chart"]').hidden = b.dataset.tab !== 'chart';
      root.querySelector('[data-pk-pane="how"]').hidden = b.dataset.tab !== 'how';
    });

    root.querySelector('.pk-sg-unit').addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      unit = b.dataset.u;
      [].forEach.call(this.children, function (x) { x.classList.toggle('pk-on', x === b); });
      render();
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-pk-size-guide]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
